import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule
    ],
    declarations: [
    ],
    exports: [
    ]
})
export class ApiSharedModule {
}
